<template>
  <v-sheet max-width="100%" :height="this.$root.windowHeight">
    <v-container class="fill-height" v-if="!selected">
      <v-col align="center">
        <v-row justify="center" align="center" class="mb-12">
          <h1>
            Gracias a {{Object.keys(countries).length}} países
          </h1>
        </v-row>
        <v-row justify="center" align="center">
          <v-sheet :height="this.$root.windowHeight * 0.7" @click="clickHandler">
              <MapChart
                  :countryData="countries"
                  LangUser="es"
                  :currency-add="false"
                  high-color="#7400b8"
                  low-color="#80ffdb"
                  @hoverCountry="hoverHandler"
                  @hoverLeaveCountry="hoverLeaveHandler"
              />
          </v-sheet>
        </v-row>
      </v-col>
    </v-container>
    <v-container class="fill-height overflow-x-hidden" v-else>
      <v-row align="center" justify="center">
        <MovieWallCard :records="movies"
                   :loaded="loaded"
                   :headline="movies.length + ' desde ' + getCountryName.of(selected)"
                   :selected.sync="selected"
                   class="mb-3"/>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import MapChart from 'vue-chart-map'
import axios from "axios";
import MovieWallCard from "@/components/MovieWallCard";
const BASE_URL = process.env.VUE_APP_API_URL

export default {
  components: {MovieWallCard, MapChart},
  name: "CountryChart",
  props: ['countries'],
  data: () => ({
    hovered: null,
    selected: null,
    movies: [],
    loaded: false,
    getCountryName: new Intl.DisplayNames(['es'], {type: 'region'})
  }),
  methods: {
    hoverHandler: function (event) {
      if (this.countries[event.code])
        this.hovered = event.code
    },
    hoverLeaveHandler	: function () {
      this.hovered = null
    },
    clickHandler : function () {
      if (this.hovered) {
        this.selected = this.hovered
        this.movies = []
        this.fetchMovies()
      }
    },
    fetchMovies() {
      this.loaded = false
      axios(
          {
            method: 'get',
            url: BASE_URL + 'stats/movies/',
            params: {
              page_size: 0,
              token: this.$route.params['token'],
              user_id: this.$route.params['user_id'],
              year: this.$route.params['year'],
              country: this.selected,
            }
          }
      ).then(res => {
        this.movies = res.data
        this.loaded = true
      })
    }
  },
}
</script>

<style scoped>

</style>
